var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "11px",
    viewBox: "0 0 10 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Star-Outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.4-Drivers---Distance",
    transform: "translate(-1004.000000, -1109.000000)",
    stroke: "#0375BA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(914.000000, 773.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23-Copy",
    transform: "translate(0.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(14.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Icon-Star-Outline",
    points: "81 5 82.1724138 8.82758621 86 8.82758621 82.8965517 11.1724138 84.1034483 15 81 12.6206897 77.8965517 15 79.1034483 11.1724138 76 8.82758621 79.8275862 8.82758621"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarOutline);
export default __webpack_public_path__ + "static/media/Icon-Star-Outline.1b0d52ac410846d5234bde35595703c4.svg";
export { ForwardRef as ReactComponent };